'use strict';

/**
 * Sample Service
 */
module.service('reportService', [ 'Restangular', '$q', reportServiceFn ]);

function reportServiceFn(Restangular, $q) {

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */
	var reportPath = '/reportclient';

	var ss = {};
	
	/*
	 * Obtiene la infromacióin de un Informe
	 */
	ss.create =  function(idClient, idPlanSampling, createModel){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath, idClient).one("/plansampling", idPlanSampling).customPOST(createModel).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	/*
	 * Obtiene la infromacióin de un Informe
	 */
	ss.get =  function(idClient, idPlanSampling, idReport){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath, idClient).one("/plansampling", idPlanSampling).one("/report", idReport).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	/*
	 * Obtiene la información de los Informes asociados a un cliente y a un plan de muestreop
	 */
	ss.searchByClient =  function(idClient, idPlanSampling){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath, idClient).one("/plansampling", idPlanSampling).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	/*
	 * Obtiene la información de los Informes asociados a un cliente y a un plan de muestreop
	 */
	ss.searchByPlanSampling =  function(idPlanSampling){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath + "/plansampling", idPlanSampling).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	ss.searchAll =  function(){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath).one("/reports").get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	ss.searchReports = function(filters) {
        var deferred = $q.defer();
        var answer = new restResponse();
      

        Restangular.all(reportPath).customGET('reports', filters).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    }

	ss.updateInvoice =  function(idReport, updateInvoiceModel){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath + "/" + idReport).customPUT(updateInvoiceModel, 'invoice').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	ss.removeInvoice =  function(idReport, updateInvoiceModel){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath + "/" + idReport).customDELETE('invoice', '').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	ss.cancelReport =  function(idReport){
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(reportPath, idReport).customPUT(null, "cancel").then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	return ss;
}
